class ExcelExportUtils {
	static getFileNameFromContentDisposition(contentDisposition) {
		if (!contentDisposition) {
			return null;
		}

		const utf8FileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);

		if (utf8FileNameMatch?.[1]) {
			return decodeURIComponent(utf8FileNameMatch[1]);
		}

		const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);

		return fileNameMatch?.[1] || null;
	}

	static downloadBlobFile({
		blob,
		fileName = "arquivo.xlsx"
	}) {
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement("a");

		link.href = url;
		link.download = fileName;

		document.body.appendChild(link);
		link.click();
		link.remove();

		window.URL.revokeObjectURL(url);
	}

	static addTimestampToFileName(fileName, date = new Date()) {
		const pad = value => String(value).padStart(2, "0");

		const datePart = [
			date.getFullYear(),
			pad(date.getMonth() + 1),
			pad(date.getDate())
		].join("-");

		const timePart = [
			pad(date.getHours()),
			pad(date.getMinutes()),
			pad(date.getSeconds())
		].join("-");

		const extensionIndex = fileName.lastIndexOf(".");
		const hasExtension = extensionIndex > 0;

		const name = hasExtension
			? fileName.slice(0, extensionIndex)
			: fileName;

		const extension = hasExtension
			? fileName.slice(extensionIndex)
			: "";

		return `${name}_${datePart}_${timePart}${extension}`;
	}
}

export default ExcelExportUtils;